if(window.location.href.includes('?type=using-tips')){
    $('.uT_video').show()
    $('.product_content').hide()
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<42;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/sqPro2_box6_${i}.avif?v=1743997431`;
    }
};
preloadImages()

$(()=>{
    if(window.innerWidth>750){
        var box7D='vertical',Wflag=true,box7V=3,box6S='top top',box9V=3,box10V=5,box11S='top top',box9G=3,box9S=12000,box9P=5
        $('.box4_video').attr('src','https://cdn.shopify.com/videos/c/o/v/0ef845f976a64b3dbc4075666b31b59a.webm')
        $('.box5_video').attr('src','https://cdn.shopify.com/videos/c/o/v/8e5fe673b90b442ca6e380d763768605.webm')

        $('.box3_mask img').hover(function(){
            $('.box3_mask img').hide()
            $('.box3_mask img:nth-child(2)').show()
        },function(){
            $('.box3_mask img').hide()
            $('.box3_mask img:nth-child(1)').show()
        })
    }else{
        box7D='horizontal',Wflag=false,box7V=2,box6S='top top+=8%',box9V=1,box10V=3,box11S='top top+=15%',box9G=1,box9S=8000,box9P=2
        $('.box4_video').attr('src','https://cdn.shopify.com/videos/c/o/v/c2284befa2a84fd2920735d6d5898204.mp4')
        $('.box5_video').attr('src','https://cdn.shopify.com/videos/c/o/v/e7d4e3eddd82458cab6786e4856afdbb.mp4')
        
        $('.box3_1 video').attr({controls:''})
    }

    $('.box3_mask img').click(function(){
        var video = $('.box3_1 video')[0]
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            // iOS Safari
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
            // IE11
            video.msRequestFullscreen();
        }
    })

    function showUp(dom){
        gsap.from(dom,{
            y:'2rem',opacity:0,ease:'none',duration:0.5,
            scrollTrigger:{
                trigger:dom,
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
            }
        })
    }

    ScrollTrigger.create({
        trigger:'.box1_1',
        start:'top top+=6%',
        end:'+=120%',
        pin:true,
        scrub:true,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            for(let i=1;i<5;i++){
                if(index>(i-1)*25){
                    $('.box1_1 div').removeClass('box1_active');
                    $(`.box1_1 div:nth-child(${i})`).addClass('box1_active');
                }
            }
        }
    })

    var box3Swiper = new Swiper('.box3Swiper', {
        effect: 'fade',
        loop:true,
        pagination: {
            el: '.box3_icon',
            clickable: true,
            renderBullet: function (index, className) {
            switch(index){
                case 0:color="linear-gradient(to bottom,#efeff9,#a4b0d6)";break;
                case 1:color="linear-gradient(to bottom,#edf5fa,#98d0d1)";break;
                case 2:color='#f1b6c8';break;
                case 3:color='#cea1fe';break;
                case 4:color='#5c659e';break;
                case 5:color='#774f43';break;
                case 6:color='#707686';break;
                case 7:color='#575757';break;
                case 8:color='#9e6a43';break;
                case 9:color='#1a1a1a';break;
                case 10:color='url(https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Luxury_Grey.png?v=1746666699)';break;
                case 11:color='url(https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Oriental_Brown.png?v=1746666699)';break;
            }
            return '<span class="' + className + '" style="background:'+color+'"></span>';
            },
        },
    })

    showUp('.box3_title')

    ScrollTrigger.create({
        trigger:'.box3',
        start:'top center',
        end:'+=2%',
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>1){
                box3Swiper.autoplay.start();
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=4%',
        end:'+=250%',
        pin:true,
        scrub:1,
        // markers:true,
        animation:gsap.timeline({ease: 'power1'})
            .to('.box4_mask img',{scale:34,duration:0.8})
            .to('.box4_mask',{background:'rgba(0,0,0,0)',duration:0.8},'-=0.8')
            .from('.box4_text1',{opacity:'0',y:'2rem',duration:0.2},'-=0.2')
            .from('.box4_text',{opacity:'0',y:'2rem',duration:0.2})
    })

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=4%',
        end:'+=120%',
        pin:true,
        scrub:1,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            // console.log(index)
            if(index>55){
                // 执行一次
                if(sq2_flag){
                    startOneo()
                    sq2_flag=false;
                }
            }
            if(index<2){
                // 重置
                sq2_flag=true,sqI1 = 60.999,sqI2 = 69
            }
        },
        animation:gsap.timeline({ease: 'power1'})
            .from('.box5_title',{opacity:'0',y:'2rem',duration:0.2})
            .from('.box5_item',{opacity:'0',y:'2rem',duration:0.2})
    })

    var sqI1 = 60.999,sqI2 = 69,sq2_flag=true,flag_sq2;
    function startOneo(){
        flag_sq2 =  setInterval(num,30)
    }
    function num(){
        sqI1++;
        sqI2--;
        $(`.box5_item div:last-child c`).text(`${sqI1}%`)
        $(`.box5_item div:first-child c`).text(`${sqI2}ms`)
        if(sqI1 > 98.999){
            clearInterval(flag_sq2);
        }
    }

    showUp('.box6_title')
    
    ScrollTrigger.create({
        trigger:'.box6',
        start:box6S,
        end:'+=150%',
        pin:true,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 40);
            $('.box6_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/sqPro2_box6_${index+1}.avif?v=1743997431`)
            $('.box6_item').toggleClass('showup',index>30)
        }
    })

    new Swiper('.box7Swiper', {
        direction: box7D,
        slidesPerView: box7V,
        loopAdditionalSlides: 10,
        allowTouchMove: !Wflag,
        speed:500,
        centeredSlides: true,
        loop:true,
        autoplay:true,
        slideToClickedSlide: true,
        pagination: {
            el: '.box7Swiper-pagination',
            clickable :true,
        },
    })

    if(Wflag){
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top top+=7%',
            end:'+=60%',
            pin:true,
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                $('.box7Swiper').toggleClass('box7_active1',index>20);
                $('.box7_circle').toggleClass('box7_active2',index>20);
                $('.box7_title div span').toggleClass('box7_active3',index>20);
                $('.box7Swiper-pagination').toggleClass('box7_active1',index>20);
            },
        })
    }else{
        showUp('.box7_title')
    }

    var box8Swiper = new Swiper('.box8Swiper', {
        effect:'fade',
        allowTouchMove: !Wflag,
    })

    var box8Swiper2 = new Swiper('.box8Swiper2', {
        slideToClickedSlide: !Wflag,
        autoplay:!Wflag,
        allowTouchMove: !Wflag,
        pagination: {
            el: '.box8Swiper-pagination',
        },
    })

    box8Swiper.controller.control = box8Swiper2;
    box8Swiper2.controller.control = box8Swiper;

    showUp('.box8_title')

    if(Wflag){
        gsap.from('.box8_flag',{
            y:'35%',scale:0,opacity:0,ease:'power1',duration:0.5,
            scrollTrigger:{
                trigger:'.box8',
                start:'top top+=30%',
                end:'+=0',
                // markers:true,
            }
        })

        ScrollTrigger.create({
            trigger:'.box8',
            start:'top top+=3%',
            end:'+=120%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                for(var i=0;i<3;i++){
                    if(index>i*40){
                        box8Swiper2.slideTo(i, 300, false);
                    }
                }
            }
        })
    }

    new Swiper('.box9Swiper', {
        slidesPerView: box9V,
        centeredSlides: !Wflag,
        slidesPerGroup: box9G,   
        loop:Wflag,
        autoplay:true,
        pagination: {
            el: '.box9Swiper-pagination',
            clickable: true,
        },
        on:{
            slideChange: function(){
                if(!Wflag){
                    $('.box9_item video').each(function(){
                        $(this).get(0).pause();
                    })
                    $('.box9_item video').eq(this.realIndex).get(0).play();
                }
            },
        },
    })

    showUp('.box9_title')

    if(Wflag){
        $('.box9_item video').hover(function(){
            $(this).get(0).play();
        },function(){
            $(this).get(0).pause();
        })
    }

    showUp('.box11_title')

    if(Wflag){
        ScrollTrigger.create({
            trigger:'.box11',
            start:'top top+=4%',
            end:'+=40%',
            pin:true,
            // markers:true,
        })
    }

    gsap.to('.box11_img',{
        clipPath:'circle(30% at 50% 63%)',ease:'power1',
        scrollTrigger:{
            trigger:'.box11',
            start:box11S,
            end:'+=20%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                $('.box11_items').toggleClass('showup',index>60)
            }
        }
    })

    var box10Swiper = new Swiper('.box10Swiper', {
        slidesPerView: box10V,
        centeredSlides: true,
        loop: true,
        autoplay:true
    })
    box10Swiper.activeIndex = 2;
    box10Swiper.update()

    //box10
    $('.box10_btn div').click(function(){
        var index = $(this).index()+1
        $('.box10_btn div').removeClass('box10_btnActive')
        $(this).addClass('box10_btnActive')
        $('.box10_icon img').hide()
        $(`.box10_icon img:nth-child(${index})`).show()
    })

    showUp('.box10_title')

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    

    $('.box2 div').click(function(){
        var index = $(this).index()+1
        if(index == 1){
            var element = document.querySelector(".box4");
            element.scrollIntoView({block: "start"});
        }else if(index == 2){
            var element = document.querySelector(".box5");
            element.scrollIntoView({block: "start"});
        }else if(index == 3){
            var element = document.querySelector(".box6");
            element.scrollIntoView({block: "start"});
        }else if(index == 4){
            var element = document.querySelector(".box7");
            element.scrollIntoView({block: "start"});
        }else if(index == 5){
            var element = document.querySelector(".box10");
            element.scrollIntoView({block: "start"});
        }
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/oxva-xlim-sq-pro-2-kit'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })

})